import { FC, PropsWithChildren } from 'react'
import { Box } from '@mui/material'

export const SuggestionContainer:FC<PropsWithChildren & {error:any}> = ({children, error}:any) => {

  return (
    <Box

      sx={{
        position: 'absolute',
        top: '100%',
        left: '50%',
        transform: 'translateX(-50%)',
        bgcolor: error ? 'white' :'background.paper',
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
        borderRadius: '8px',
        border: error ? '1px solid': 'unset',
        borderColor: error ? 'error.main' : '#E2E8F0',
        color: error ? 'error.main': 'inherit',
        fontSize: '14px',
        zIndex: 1000,
        mt: 0.5,
        gap:1,
        maxHeight: '300px',
        maxWidth:'375px',
        width:'100%',
        overflowY: 'auto',

        '&::-webkit-scrollbar': {
          width: '6px',
          backgroundColor: 'transparent',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: 'transparent',
          borderRadius: '3px',
        },
        '&:hover::-webkit-scrollbar-thumb': {
          backgroundColor: '#CBD5E1',
        },
        scrollbarWidth: 'thin',
        scrollbarColor: 'transparent transparent',
        '&:hover': {
          scrollbarColor: '#CBD5E1 transparent',
        },
      }}
    >
      {children}
    </Box>
  )
}